// ===============================
// CO-FOUNDERS
// ===============================
import example from "../../../Assets/Team/ex.png"
import Image1 from "../../../Assets/Team/nalin.png";
import Image2 from "../../../Assets/Team/vishal.png";
import Founder1 from "../../../Assets/Team/founder1.png"
import Founder2 from "../../../Assets/Team/founder2.png"

export const founders = [
  {
    id: 1,
    name: "Charan Yadav",
    role: "Founder",
    badge: "CEO & FOUNDER",
    image: Founder1,
    imagePosition: "left",
    quote:
      "Our mission is to ensure that no commercial vehicle remains stranded on Indian roads.",
    linkedin: "https://www.linkedin.com/in/cs-yadav-7006baa1/",
  },

//   {
//     id: 2,

//     name: "Vikram Singh",

//     role: "Founder & Managing Director",

//     badge: "CEO & FOUNDER",

//     image: Founder2,
//     //   "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/team/founder2.png",

//     imagePosition: "right",

//     quote:
//       "Building a nationwide network of trust, technology and real-time roadside assistance.",

//     linkedin: "#",
//   },
];

// ===============================
// LEADERSHIP TEAM
// ===============================

export const leadership = [
  {
    id: 1,
    name: "Nalin Malik",
    role: "President - Operations",
    image: Image1,
    description:
      "Leading nationwide roadside operations and ensuring exceptional customer support.",
    linkedin: "https://www.linkedin.com/in/nalin-malik-646688242/",
  },

  {
    id: 2,
    name: "Vishal",
    role: "General Manager",
    image: Image2,
    description:
      "Managing field operations, service quality and rapid response across India.",
    linkedin: "https://www.linkedin.com/in/vishal-ba186b143/",
  },

  {
    id: 3,

    name: "Devender",
    role: "VP - Operations",
    image:
      "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/team/yatendra.png",
    description:
      "Building and managing India's largest commercial vehicle assistance network.",
    linkedin: "#",
  },

  // {
  //   id: 4,
  //   name: "",
  //   role: "",
  //   image:
  //     "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/team/mohan.png",
  //   description:
  //     "Driving technology innovation and building the ClaimPro digital ecosystem.",
  //   linkedin: "#",
  // },
];

// ===============================
// TEAM SECTION
// ===============================

export const teamInfo = {
   title: "ONE TEAM. ONE GOAL.",
  subtitle: "ALWAYS THERE, EVERYWHERE.",

  description:
    "Dedicated professionals working together to provide India's fastest and most reliable roadside assistance network.",

  image:
    example,

  stats: [
    {
      value: "50+",
      label: "Dedicated Professionals",
    },

    {
      value: "28",
      label: "States Covered",
    },

    {
      value: "10,000+",
      label: "Cases Supported",
    },

    {
      value: "15+",
      label: "Years Average Experience",
    },
  ],
};